import { inject, observer } from "mobx-react";
import { Button } from "primereact/button";
import React from "react";
import { RouterAddress } from "../../../constants/RouterAddress";
import { publicPageContainerStyle, publicSectionCardStyle, renderPublicHero } from "../../../components/general/publicPageStyles";

@observer
class NotFoundPage extends React.Component {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
      <div style={publicPageContainerStyle}>
        <div>
          {renderPublicHero(
            "Simple public navigation",
            "Page not found",
            "The page you were looking for does not exist or may have moved.",
          )}
        </div>
        <div style={{ ...publicSectionCardStyle, textAlign: "center", marginTop: "1rem" }} className="p-5">
          <div style={publicSectionCardStyle}>
            <div style={{ fontSize: "1.8rem", fontWeight: 700, color: "#0f3d63", marginBottom: "0.75rem" }}>
              Page not found
            </div>
            <div style={{ color: "#5f7488", lineHeight: 1.7 }}>
              The page you were looking for does not exist or may have moved. Use the button below to get back to login.
            </div>
          </div>
          <Button style={{ marginTop: "20px" }} severity="warning" label="Go to Login Page" onClick={() => {
            window.location.href = RouterAddress.LOGIN_PAGE;
          }}></Button>
        </div>
      </div>
    );
  }
}

export default NotFoundPage;
